import React from 'react'
import './Mutual.css'
import client2 from '../../../assets/client2.jpg'
import img2 from "../../../assets/img2.jpg";
import mutualimg from "../../../assets/mutualimg.jpg";
import Footer from '../../../general/footer/Footer';
import { Link } from 'react-router-dom';


const Mutual = () => {
    return (
        <div>
            <div className="insurance-section">
                <div className="insurance-content">
                    <div className="breadcrumb">
                        <span>Home</span> &nbsp;•&nbsp;
                        <span>Our Services</span> &nbsp;•&nbsp;
                        <span className="active">Mutual Funds</span>
                    </div>
                    <h1>Mutual Funds</h1>
                    <p>
                        At PSJ Capital Ventures, we curate mutual fund portfolios tailored to your financial goals, risk appetite, and time horizon - backed by in-depth research and ongoing reviews.
                    </p>
                </div>
                <div className="insurance-image">
                    <img src={mutualimg} alt="Insurance Family" />
                </div>
            </div>

            <div className="travel-details-container">
                {/* LEFT SECTION */}
                <div className="travel-details-left">
                    <h2>What Are Mutual Funds?</h2>
                    <p>
                        A mutual fund is an investment vehicle that pools money from multiple investors to invest in a diversified portfolio of securities like stocks, bonds, money market instruments, and other assets. These funds are managed by professional fund managers and are regulated by the Securities and Exchange Board of India (SEBI).
                    </p>
                    <h3 style={{ color: 'black' }}>Why Mutual Funds Matter</h3>
                    <p className="bold-line">
                        Mutual funds remain one of the most versatile and trusted investment avenues for building long-term wealth. Whether you're a first-time investor or a seasoned professional, mutual funds offer an accessible, professionally managed way to diversify across asset classes, geographies, and strategies - all within a regulated and transparent structure.
                    </p>

                    <h3 style={{ color: 'black' }}>Key Terminologies</h3>
                    <div className="plan-columns">

                        <div>
                            <h5>1. 	NAV (Net Asset Value): </h5>
                            <p>The per-unit price of a mutual fund. It is calculated as:(Total Assets – Total Liabilities) ÷ Number of Outstanding Units
                            </p>
                            <h5>2. 	Expense Ratio: </h5>
                            <p>The annual fee charged by the mutual fund for managing your money. A lower expense ratio is generally preferred, especially in passive funds.</p>
                        </div>
                        <div>
                            <h5>3. 	SIP (Systematic Investment Plan): </h5>
                            <p>A method to invest a fixed amount regularly (e.g., monthly) into a mutual fund, helping in rupee-cost averaging and disciplined investing.</p>
                            <h5>4. 	SWP (Systematic Withdrawal Plan): </h5>
                            <p>A structured way to withdraw a fixed amount at regular intervals, often used during retirement.</p>
                        </div>
                    </div>

                    {/* Service Benefits */}
                    <div className="benefits-section">
                        <div className="benefits-image">
                            <img src={img2} alt="Service Benefits" />
                        </div>
                        <div className="benefits-list">
                            <h4>Our Mutual Fund Offerings</h4>
                            {/* <p>
                                We help you invest across a wide spectrum of mutual fund categories:
                            </p> */}
                            <ul>
                                <li>✓ 	Equity Mutual Funds </li>
                                <li>✓ 	Debt Mutual Funds </li>
                                <li>✓ 	Hybrid Funds </li>
                                <li> ✓	ELSS (Equity-Linked Savings Scheme) </li>
                                <li> ✓  Thematic & International Funds </li>
                            </ul>
                        </div>
                    </div>

                    {/* More Benefits */}
                    <div className="service-benefits">
                        <h3>Benefits of Mutual Funds</h3>

                        <ul>
                            <li>✓ 	Diversification</li>
                            <li>✓ 	Professional Management</li>
                            <li>✓ 		Liquidity</li>
                            <li>✓ 		Affordability</li>
                            <li>✓ 		Transparency</li>
                        </ul>
                        <p>
                            Let’s Build Your Mutual Fund Portfolio Explore our recommended strategies or book a free consultation to get your portfolio reviewed. At PSJ Capital Ventures, we make mutual fund investing smarter, not harder.

                        </p>
                    </div>
                    <Link to='/contact'><button className="get-touch-btn">Get in Touch →</button></Link>
                </div>

                {/* RIGHT SECTION */}
                <div className="travel-details-right">
                    <div className="services-box">
                        <h4>Our Services</h4>
                        <ul>
                            <Link to='/portfolio-management-services'><li>Portfolio Management Services →</li></Link>
                            <Link to='/alternative-investment-funds'><li>Alternative Investment Funds →</li></Link>
                            <Link to='/macro-treasury-research'><li>Macro/Treasury Research →</li></Link>
                            <Link to='/nri-corner'><li>NRI Corner →</li></Link>
                            <Link to='/family-offices'><li>Family Offices →</li></Link>
                            <Link to='/insurance'><li>Insurance →</li></Link>
                            <Link to='/loan-syndication'><li>Loan Syndication→</li></Link>
                            <Link to='/sme-ipo-advisory'><li>SME IPO Advisory →</li></Link>
                            <Link to='/fundraising-assistance'><li>Fundraising Assistance →</li></Link>
                            <Link to='/stock-broking'><li>Stock Broking →</li></Link>
                        </ul>
                    </div>

                    <div className="advisor-box">
                        <img src={client2} alt="Advisor" />
                        <p>Make your dream life get professional help</p>
                        <div className="contact-info">
                            <span>📞 CONTACT US</span>
                            <p>+91 8108 430 942</p>
                        </div>
                    </div>
                </div>
            </div>
            <br></br><br></br><br></br>
            <Footer />
        </div>
    )
}

export default Mutual